import { useResize } from '@taxdown/piccolo-web';
import Custom from './components/Custom';
import Default from './components/Default';

const View = ({
  base64Pdf,
  base64Binary,
  fileType,
}: {
  base64Pdf: string;
  base64Binary: string;
  fileType: string;
}): JSX.Element => {
  const { isMobile } = useResize();

  return isMobile ? (
    <Custom base64Pdf={base64Pdf} base64Binary={base64Binary} fileType={fileType} />
  ) : (
    <Default base64Pdf={base64Pdf} />
  );
};

export default View;
